import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "./auth/slice";
import commonSlice from "./common/slice";
import storySlice from "./stories/slice";
import queriesSlice from "./queries/slice";
import bookmarksSlice from "./bookmarks/slice";
import otherUserProfileSlice from "./otherUserProfile/slice";
import chatsSlice from "./chat/slice";

const rootReducer = combineReducers({
  auth: authReducer,
  bookmarks: bookmarksSlice,
  common: commonSlice,
  chats: chatsSlice,
  queries: queriesSlice,
  otherUserProfile: otherUserProfileSlice,
  stories: storySlice,
});

export default rootReducer;
